import type { Template } from "@/types";

export const SQ_07_H7_V0: Template[] = [
    {
        id: "sq-07-h7v0-01",
        name: "SQ 01 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 41, y: 147, width: 314, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 41, y: 363, width: 314, height: 207, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 147, width: 314, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 363, width: 314, height: 207, rotation: 0, imageRotation: 0 },
            { id: "5", x: 819, y: 95, width: 253, height: 172, rotation: 0, imageRotation: 0 },
            { id: "6", x: 819, y: 275, width: 513, height: 347, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 95, width: 252, height: 172, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h7v0-02",
        name: "SQ 02 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 41, y: 147, width: 636, height: 423, rotation: 0, imageRotation: 0 },
            { id: "2", x: 866, y: 147, width: 207, height: 136, rotation: 0, imageRotation: 0 },
            { id: "3", x: 866, y: 291, width: 207, height: 136, rotation: 0, imageRotation: 0 },
            { id: "4", x: 866, y: 435, width: 207, height: 135, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1081, y: 147, width: 206, height: 136, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1081, y: 291, width: 206, height: 136, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1081, y: 435, width: 206, height: 135, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h7v0-03",
        name: "SQ 03 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 66, y: 117, width: 585, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 471, width: 190, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 471, width: 190, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 462, y: 471, width: 189, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 783, y: 117, width: 585, height: 293, rotation: 0, imageRotation: 0 },
            { id: "6", x: 783, y: 418, width: 289, height: 182, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 418, width: 288, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h7v0-04",
        name: "SQ 04 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 29, y: 75, width: 279, height: 184, rotation: 0, imageRotation: 0 },
            { id: "2", x: 29, y: 267, width: 279, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 29, y: 458, width: 279, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 316, y: 75, width: 802, height: 566, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1126, y: 75, width: 279, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1126, y: 267, width: 279, height: 183, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1126, y: 458, width: 279, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h7v0-05",
        name: "SQ 05 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 49, y: 51, width: 664, height: 436, rotation: 0, imageRotation: 0 },
            { id: "2", x: 721, y: 51, width: 664, height: 436, rotation: 0, imageRotation: 0 },
            { id: "3", x: 49, y: 495, width: 261, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 318, y: 495, width: 261, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 587, y: 495, width: 261, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 856, y: 495, width: 261, height: 171, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1125, y: 495, width: 260, height: 171, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h7v0-06",
        name: "SQ 06 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 73, y: 111, width: 316, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 397, y: 111, width: 316, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 721, y: 111, width: 316, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1045, y: 111, width: 316, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 73, y: 327, width: 424, height: 279, rotation: 0, imageRotation: 0 },
            { id: "6", x: 505, y: 327, width: 424, height: 279, rotation: 0, imageRotation: 0 },
            { id: "7", x: 937, y: 327, width: 424, height: 279, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h7v0-07",
        name: "SQ 07 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 111, width: 233, height: 160, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 279, width: 233, height: 160, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 447, width: 233, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 241, y: 447, width: 232, height: 159, rotation: 0, imageRotation: 0 },
            { id: "5", x: 481, y: 447, width: 232, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 241, y: 111, width: 472, height: 328, rotation: 0, imageRotation: 0 },
            { id: "7", x: 721, y: 111, width: 713, height: 495, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h7v0-08",
        name: "SQ 08 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 111, width: 713, height: 495, rotation: 0, imageRotation: 0 },
            { id: "2", x: 721, y: 111, width: 233, height: 160, rotation: 0, imageRotation: 0 },
            { id: "3", x: 721, y: 279, width: 233, height: 160, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 447, width: 233, height: 159, rotation: 0, imageRotation: 0 },
            { id: "5", x: 962, y: 447, width: 232, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 962, y: 111, width: 472, height: 328, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1202, y: 447, width: 232, height: 159, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h7v0-09",
        name: "SQ 09 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 175, width: 713, height: 367, rotation: 0, imageRotation: 0 },
            { id: "2", x: 721, y: 175, width: 233, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 721, y: 363, width: 233, height: 179, rotation: 0, imageRotation: 0 },
            { id: "4", x: 962, y: 175, width: 232, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 962, y: 363, width: 232, height: 179, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1202, y: 175, width: 232, height: 180, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1202, y: 363, width: 232, height: 179, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h7v0-10",
        name: "SQ 10 - H7V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h7_v0_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 59, y: 160, width: 599, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 776, y: 160, width: 195, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 776, y: 295, width: 195, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 776, y: 430, width: 195, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 160, width: 195, height: 127, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1182, y: 160, width: 194, height: 127, rotation: 0, imageRotation: 0 },
            { id: "7", x: 979, y: 295, width: 397, height: 262, rotation: 0, imageRotation: 0 }
        ],
    },
   

];
